import { Component } from '@angular/core';
import { ReportsComponent } from '@dato-pages/reports/reports.component';
import { AgingTransDocumentEndpoint } from '@dato-proxy/endpoints/agingtransdocument.endpoint';
import { CompanyEndpoint } from '@dato-proxy/endpoints/company.endpoint';
import { CustomerEndpoint } from '@dato-proxy/endpoints/customer.endpoint';
import { DeliveryEndpoint } from '@dato-proxy/endpoints/delivery.endpoint';
import { FileEndpoint } from '@dato-proxy/endpoints/file.endpoint';
import { InvoiceEndpoint } from '@dato-proxy/endpoints/invoice.endpoint';
import { LedgerEndpoint } from '@dato-proxy/endpoints/ledger.endpoint';
import { EnumSystemTypes } from '@dato-proxy/enums';
import { ToolbarSettings } from '@m4u-angular/base/classes/BaseClasses';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { Globals } from '../../../../_globals';

@Component({
    providers: ServiceBagServices,
    selector: 'app-reports-mobile',
    templateUrl: './reports-mobile.component.html',
    styleUrls: ['./reports-mobile.component.scss']
})
export class ReportsMobileComponent extends ReportsComponent {
    public downloadOptions = ['PDF', 'ZIP'];
    constructor(A: ServiceBagService,
        ledgerEndpoint: LedgerEndpoint,
        invoiceEndpoint: InvoiceEndpoint,
        agingTransDocumentEndpoint: AgingTransDocumentEndpoint,
        deliveryEndpoint: DeliveryEndpoint,
        customerEndpoint: CustomerEndpoint,
        fileEndpoint: FileEndpoint,
        companyEndpoint: CompanyEndpoint) {
        super(A, ledgerEndpoint, invoiceEndpoint, agingTransDocumentEndpoint, deliveryEndpoint, customerEndpoint, fileEndpoint, companyEndpoint);
    }

    override InitTabs(): void {
        super.InitTabs();
        this.State.ReportTabs = this.State.ReportTabs.filter(x => x.Type !== 2); // remove Aging for mobile
        //if (Globals.SystemOption.SystemType === EnumSystemTypes.Landlord || Globals.SystemOption.SystemType === EnumSystemTypes.Zulu) return;
    }

    override OnGetToolbarSettings() {
        return new ToolbarSettings;
    }

    OnAccountingTypeChanged() {
        this.State.Documents = [];
        this.State.TotalSum = 0;
    }

}
